import { Globe, Plug } from 'lucide-react'

import { defineModule } from '@/lib/module-routes'
import { SSO_PERMISSIONS } from '@/lib/permissions'
import {
  authLoginRoute,
  authCallbackRoute,
  authResetRoute,
  signupRoute,
  entityFederationRoute,
  oauthConsentRoute,
  connectedAppsRoute,
  customDomainSettingsRoute,
} from './routes'

export const identityModule = defineModule({
  routes: [
    authLoginRoute,
    authCallbackRoute,
    authResetRoute,
    signupRoute,
    entityFederationRoute,
    oauthConsentRoute,
    connectedAppsRoute,
    customDomainSettingsRoute,
  ],
  navigation: {
    admin: [
      {
        to: '/$entityId/federation',
        label: 'Federation',
        icon: Plug,
        permission: SSO_PERMISSIONS.manage,
        section: 'configure',
        order: 20,
      },
      {
        to: '/$entityId/settings/custom-domain',
        label: 'Custom domain',
        icon: Globe,
        permission: SSO_PERMISSIONS.manage,
        section: 'settings',
        order: 30,
      },
    ],
  },
})
